export const RIGHT_NAV_ALIGN_ITEMS = 'center';
export const BRAND_LOGO_NAME_ID = 'bk_logo_title';
export const MEDIA_QUERY_HEADER = 'desktopLarge';
